module.exports = __webpack_public_path__ + "static/media/Top_Building_Dark.58c8ce4f.png";